/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_1_HInputs */

const en_privacy_1_h = /** @type {(inputs: Privacy_1_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What we collect`)
};

const id_privacy_1_h = /** @type {(inputs: Privacy_1_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang kami kumpulkan`)
};

/**
* | output |
* | --- |
* | "What we collect" |
*
* @param {Privacy_1_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_1_h = /** @type {((inputs?: Privacy_1_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_1_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_1_h(inputs)
	return en_privacy_1_h(inputs)
});